import SectionCard from '../shared/SectionCard'
import ContactsFiltersBar from './ContactsFiltersBar'
import { Stack } from './styled-components'
import useContacts from '@/containers/DevToolsNew/Contacts/useContacts'
import ContactsTable from '@/containers/DevToolsNew/Contacts/ContactsTable'

const ContactsPage = () => {
  const { filters, countrySelect, table } = useContacts()

  return (
    <Stack>
      <SectionCard>
        <ContactsFiltersBar filters={filters} countrySelect={countrySelect} />
      </SectionCard>

      <ContactsTable
        rows={table.rows}
        isLoading={table.isLoading}
        error={table.error}
        footer={table.footer}
        pagination={table.pagination}
      />
    </Stack>
  )
}

export default ContactsPage
